import { Environment } from '@1debit/device-intelligence';

import { IS_DEV_ENV, IS_PROD_ENV } from 'consts/appConsts';

export const deviceIntelligenceEnvironment = IS_DEV_ENV
  ? Environment.Development
  : IS_PROD_ENV
    ? Environment.Production
    : Environment.NonProduction;
